export const environment = {
  production: false,
  apiUrl: 'https://neworg.prismab.com/api',
  organizationName: 'org.agrogreen.com',
  // apiUrl: '//app.prismab.com/api'
  // apiUrl: 'http://localhost:3005'
};
